import { Model } from ".";
export default class Bonus extends Model {
	get singularNoun() {
		return "bonus";
	}

	get pluralNoun() {
		return "bonuses";
	}

	resource() {
		return "bonus";
	}
}
